import _L from "../../../util/Labels";
import { _ModalThingsBase } from "./ModalThingsBase";
import { ModalThingsUtil as util } from "./Utils";

type IModalThingsBase1 = util.IModalThingsBase1
type IModalThings<TExtras = any> = util.IModalThings<TExtras>

export interface IModalConfirmacionConfig extends Omit<IModalThingsBase1, keyof Pick<IModalThingsBase1, "Title">> {
    /** @default "Mensaje de confirmación" */
    Title?: string;
    /** Agrega un label con el valor
     * * Nota: acepta html en la cadena
     */
    Message?: string;
    /** Personaliza contenido extra despues del mensaje de confirmación */
    DrawContent?: (content: TSelectionHTML<"div">, modalThings: IModalThings) => void;
    /** @default 400 px */
    Width?: NonNullable<number>;
    OnClose?: () => void;
    OnAccept?: (modalThings: IModalThings) => Promise<any> | any;
    VerifyOnAcceptRes?: boolean;
}

/** Si no se define OnAccept, el botón de "Cancelar" | "No" no será visible
 * * Retorna null, si no se tiene permisos
 */
export function _ModalConfirmacion(conf: IModalConfirmacionConfig): (IModalThings | null) {
    let finalConf: IModalConfirmacionConfig = {
        ... {
            Width: 400,
            StrModalBotons: "aceptar_cancelar"
        },
        ...conf
    }
    if (finalConf.Action == null) {
        finalConf.Title = (finalConf.Title || _L("general.msjconfirma"));
    }

    if (!util.ActionPermission(finalConf.Action, finalConf.Modulo, finalConf.IdsEscuelas)) {
        return null;
    }

    // >> LangModuleContext Fix
    const langContextTitle = util.GetLangContext(finalConf.LangModuleKeyInContext, finalConf.Title, finalConf.Modulo, finalConf.Action);
    finalConf.LangModuleKeyInContext = langContextTitle.ModuleKeyInContext;

    const langContextMessage = util.GetLangContext(finalConf.LangModuleKeyInContext, finalConf.Message, finalConf.Modulo, finalConf.Action);

    // >> Build modal
    let modalT = _ModalThingsBase(langContextTitle.StringTag, finalConf.Width, "body_temp");

    if (finalConf.Message) {
        modalT.CurrentBody.append("label")
            .html(langContextMessage.StringTag)
            .style("white-space", "pre-line");
    }

    if (finalConf.DrawContent) {
        finalConf.DrawContent(modalT.CurrentBody, modalT);
    }

    if (finalConf.OnAccept) {
        modalT.BtnLeft.classed("hide_transparent", false);
    } else {
        modalT.BtnLeft.remove();
    }
    modalT.Modal._OnClose(finalConf.OnClose);
    modalT.Modal._FooterSelection
        .style("justify-content", null);

    modalT.BtnLeft
        .style("margin-right", "0px")
        .on("click", () => {
            modalT.Modal._Ocultar();
        })

    modalT.BtnRight
        .on("click", async () => {
            if (modalT.BtnRight.classed("btn_disable")) return;
            modalT.Modal._DeshabilitarBtns();
            if (finalConf.OnAccept) {
                let onAcceptRes = finalConf.OnAccept(modalT);
                // console.warn("Es promesa", (onAcceptRes instanceof Promise), (onAcceptRes instanceof Promise))
                if (onAcceptRes && onAcceptRes instanceof Promise) {
                    modalT.Progress.node()._Visible = true;
                    await onAcceptRes;
                    modalT.Progress.node()._Visible = false;
                }
                // else {
                //     finalConf.OnAccept(modalT);
                // }
                if (conf.VerifyOnAcceptRes && onAcceptRes === false) {
                    modalT.Modal._HabilitarBtns();
                    return
                };
            }
            modalT.Modal._Ocultar();
        });

    util.AjustaTextoBotonesModal(modalT, finalConf.StrModalBotons);

    return modalT;
}